import React, { FC, useCallback, useEffect, useRef } from 'react';
import { createFilesBiOptionsMap } from '../../../utils/bi';
import { stopPropagation } from '../../../utils/dom/domEvents';
import styles from './FileInput.scss';
import { IOuter } from './FileInput.types';
import { fedopsLogger } from '../../../services/loggers/fedopsLogger';
import { FedOpsInteraction } from '../../../constants/FedOpsInteraction';

export const FileInput: FC<IOuter> = ({ onFilesInputOpen, multiple = true, children, onFiles, biOrigin, biTarget }) => {
  const uploadInputRef = useRef<HTMLInputElement>(null);

  const onCancel = () => {
    fedopsLogger.interactionEnded(FedOpsInteraction.OpenUploadDialog);
  };

  useEffect(() => {
    const fileInput = uploadInputRef.current;
    uploadInputRef.current.addEventListener('cancel', onCancel);

    return () => {
      fileInput.removeEventListener('cancel', onCancel);
    };
  }, []);

  const openFilesInput = useCallback(
    (event) => {
      if (onFilesInputOpen) {
        onFilesInputOpen(event);
      }

      if (uploadInputRef.current) {
        uploadInputRef.current.click();
      }
    },
    [onFilesInputOpen],
  );

  const handleFiles = useCallback(
    (event) => {
      const files = event.target.files;

      fedopsLogger.interactionEnded(FedOpsInteraction.OpenUploadDialog);

      onFiles(files, null, {
        bi: {
          files: createFilesBiOptionsMap(files, biOrigin, biTarget),
        },
      });
      event.target.value = null;
    },
    [onFiles, biOrigin, biTarget],
  );

  return (
    <>
      {children({ openFilesInput })}
      <input
        data-hook="files-input"
        type="file"
        className={styles.input}
        multiple={multiple}
        ref={uploadInputRef}
        onChange={handleFiles}
        onClick={stopPropagation}
      />
    </>
  );
};
